import React from "react";
const SliderItem = React.memo(function  ({src = null, redirectUrl}) {
    if (!src) return;
    return <div className="embla__slide">
        <a href={redirectUrl}>
            <img src={src} className="embla__slide__number" alt={"slider"} loading="lazy" />
        </a>
    </div>
}, (prevProps, nextProps) => prevProps.src === nextProps.src)

export default SliderItem